import type { PricingContent } from "../types";

export const pricing: PricingContent = {
  title: "Et katalog, der følger fronten.",
  lead:
    "Førende open-weight modeller, serveret i Danmark, og kataloget følger " +
    "state-of-the-art udviklingen, så nye modeller løbende tilføjes. Afregnes i " +
    "kredit på den nationale platform UCloud. " +
    "Ingen udenlandske fakturaer, ingen betaling per token i udlandet.",
  tableHeaders: [
    "Model",
    "Bedst til",
    "Kontekst",
    "Kredit / 1M ind",
    "Kredit / 1M ud",
    "Kredit / 1M cachelagret",
  ],
  models: [
    { bestFor: "Kompleks ræsonnement, analyse og agentarbejde" },
    { bestFor: "Multimodal, høj volumen og latensfølsomme opgaver" },
  ],
  note:
    "Til de fleste arbejdsbelastninger giver GLM 5.3-Flash den bedste værdi; skaler op til GLM 5.3 til komplekst ræsonnement. Priser vises i kredit pr. 1M tokens. Kataloget vokser løbende: nye state-of-the-art-modeller tilføjes, efterhånden som de udgives, og danske modeller fra Danish Foundation Models, trænet på UCloud med national støtte, er på vej. Dine data bruges aldrig til at træne nogen af modellerne.",
};
